import React from "react";

const MYRSymbol = ({ height, width, fillColor }) => {
  return (
    <svg
      width={width ? width : 45}
      height={height ? height : 23}
      viewBox="0 0 45 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9375 14.1094L18.6719 22.6875V23H14.4219L9.01562 14.5469H4.53125V23H0.78125V0.59375H10.25C12.4896 0.59375 14.2708 1.25521 15.5938 2.57812C16.9167 3.90104 17.5781 5.54688 17.5781 7.51562C17.5781 9.11979 17.1667 10.4948 16.3438 11.6406C15.5417 12.7969 14.4062 13.6198 12.9375 14.1094ZM4.53125 3.98438V11.1562H10.0312C11.2708 11.1562 12.1875 10.8281 12.7812 10.1719C13.4062 9.51562 13.7188 8.64062 13.7188 7.54688C13.7188 6.47396 13.4062 5.60938 12.7812 4.95312C12.1354 4.30729 11.2188 3.98438 10.0312 3.98438H4.53125ZM22.3787 23V0.59375H26.6444L33.6444 12.8281H33.7694L40.785 0.59375H44.9725V23H41.3631V6.54688H41.2225L33.8319 19.2188H33.5194L26.1287 6.45312H26.0037V23H22.3787Z"
        className={fillColor ? fillColor : "fill-text-primary"}
      />
    </svg>
  );
};

export default MYRSymbol;
